import {launchDarkly} from "utils/launchDarkly";

export const RENAME_TO_APPROVALS_FLAG = "fe-rename-to-approvals";

export function isRenamedToApprovals(): boolean {
    return launchDarkly.userClient?.variation(RENAME_TO_APPROVALS_FLAG, false) ?? false;
}

export function productName(): string {
    return isRenamedToApprovals() ? "Approvals" : "Approval";
}

// The renamed product drops the "Visma.net" prefix.
export function fullProductName(): string {
    return isRenamedToApprovals() ? "Approvals" : "Visma.net Approval";
}

export function productWindowTitle(): string {
    return isRenamedToApprovals() ? " Approvals" : " Approval | Visma.net";
}
